import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import React from 'react';
import logo from '../assets/SVG/Clinic Logo.png';
// import logo from '../../../../../assets/SVG/Clinic Logo.png';
import { Box, Typography, SxProps, Theme } from '@mui/material';

export async function generatePDF(element: HTMLElement, filename: string) {
  const canvas = await html2canvas(element, { scale: 2, useCORS: true });
  const imgData = canvas.toDataURL('image/png');
  const pdf = new jsPDF('p', 'mm', 'letter');
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
  pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  pdf.save(`${filename}.pdf`);
}




export const ClinicHeader = () => (
  <Box sx={{ display: 'flex', height: 120, borderBottom: '0.1px solid #3f3f3f' }}>
    {/* Left Section with Background */}
    <Box
      sx={{
        backgroundColor: '#fdf4f1',
        padding: 2,
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          ABC Fertility Centre
        </Typography>
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          756 University Avenue, Lake Jeniferberg - 359670
        </Typography>
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          <strong>Email :</strong> ramon.morissette54@gmail.com
        </Typography>
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          <strong>Mobile No. :</strong> 578-778-3291
        </Typography>
      </Box>
    </Box>

    {/* Divider */}
    <Box sx={{ width: '20px', backgroundColor: '#e97c5e' }} />

    {/* Right Section with Logo */}
    <Box
      sx={{
        width: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 2,
        backgroundColor: '#fff',
      }}
    >
      <Box
        component="img"
        src={logo}
        alt="Clinic Logo"
        sx={{ width: 100, height: 'auto', objectFit: 'contain' }}
      />
    </Box>
  </Box>
);


export const InfoGrid: React.FC<{ data: string[][] }> = ({ data }) => (
  <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    fontSize: 14,
    border: '1px solid #e0e0e0',
    borderRadius: 2,
    backgroundColor: '#fff',
  }}>
    {data.map(([label1, value1, label2, value2], index) => (
      <Box key={index} sx={{
        display: 'flex',
        justifyContent: 'space-between',
        px: 2,
        py: 1.5,
        backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff',
        borderBottom: index !== data.length - 1 ? '1px solid #e0e0e0' : 'none',
      }}>
        {[label1, value1].every(Boolean) && (
          <Box sx={{ flex: 1 }}>
            <Typography variant="body2"><strong>{label1}:</strong> {value1}</Typography>
          </Box>
        )}
        {[label2, value2].every(Boolean) && (
          <Box sx={{ flex: 1 }}>
            <Typography variant="body2"><strong>{label2}:</strong> {value2}</Typography>
          </Box>
        )}
      </Box>
    ))}
  </Box>
);

export const tableCellStyle: SxProps<Theme> = {
  border: '1px solid #ccc',
};
